import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const getBaskets = (apiUrl) => (query) => {
  const url = joinUrl(apiUrl, `/checkoutservice/pb/baskets/`);
  return requestUtility.get(url, query);
};

export default getBaskets;
